import { render } from "./App.vue?vue&type=template&id=3562d236&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=3562d236&lang=scss"

import exportComponent from "/Users/andrski/developing/web/client_shina_m1/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__